export default __webpack_public_path__ + "static/media/Heather_J_Richman_AHV_In_Moms_We_Trust.38bec16d.jpg";